import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { EnhancedFileUploadArea } from './FileUpload';
import { useOCRProcessing } from '../hooks';
import { ManualEntryForm } from './Forms';
import { getAge } from '../../../../v2/Utils/AgeCalc';
import { ReusableOCRFailureModal } from '../../../Common/OCR';

const InlineBeneficiaryForm = ({ 
    staffData, 
    onSave, 
    onCancel,
    showManualEntry = true
}) => {
    const [currentStep, setCurrentStep] = useState('upload'); // 'upload', 'manual'
    const [ocrFailureModalOpen, setOcrFailureModalOpen] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');

    const {
        isLoading,
        error,
        extractedData,
        uploadedFile,
        handleFileUpload,
        resetOCR
    } = useOCRProcessing({
        consent: 'Y'
    });

    const handleFileUploadWithOCRHandling = async (file) => {
        const success = await handleFileUpload(file);
        if (!success) {
            setOcrFailureModalOpen(true);
        }
    };

    const handleTryAgain = () => {
        setOcrFailureModalOpen(false);
        setCurrentStep('upload');
        resetOCR();
    };

    const handleEnterManually = () => {
        setOcrFailureModalOpen(false);
        setCurrentStep('manual');  
    };

    const handleBackToUpload = () => {
        setCurrentStep('upload');
        resetOCR();
        setPhoneNumber('');
    };

    const handleEditManually = () => {
        setCurrentStep('manual');
        
    };

    const handleConfirmExtractedData = () => {
        const calculatedAge = extractedData.dob ? getAge(extractedData.dob) : null;
        const beneficiaryData = {
            ...extractedData,
            phone_number: phoneNumber,
            beneficiary_id: Date.now(),
            staff_no: staffData.staff_no,
            age: calculatedAge,
            ocr_verified: currentStep === 'upload' ? true : false,
        };
        onSave(beneficiaryData);
    };
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: currentStep === 'manual' && 1 }}>
            <Typography variant="h2">
                Add Beneficiary Details
            </Typography>

            {currentStep === 'upload' && (
                <EnhancedFileUploadArea
                    onFileUpload={handleFileUploadWithOCRHandling}
                    isLoading={isLoading}
                    error={error}
                    uploadedFile={uploadedFile}
                    extractedData={extractedData}
                    phoneNumber={phoneNumber}
                    onPhoneChange={setPhoneNumber}
                    onConfirm={handleConfirmExtractedData}
                    onEditManually={handleEditManually}
                    uploadTitle="Upload Beneficiary Aadhar"
                    processingText="Processing Aadhar..."
                    onFileDelete={() => {
                        resetOCR();
                    }}
                />
            )}

            {currentStep === 'manual' && (
                <ManualEntryForm
                    staffData={staffData}
                    onSave={onSave}
                    onCancel={handleBackToUpload}
                    initialData={{
                        ...extractedData,
                        phone_number: phoneNumber,
                        age: extractedData.dob ? getAge(extractedData.dob) : '',
                    }}
                />
            )}

            <ReusableOCRFailureModal
                open={ocrFailureModalOpen}
                onClose={() => {
                    setOcrFailureModalOpen(false);
                    resetOCR();
                }}
                showManualEntry = {showManualEntry}
                onTryAgain={handleTryAgain}
                onEnterManually={handleEnterManually}
                errorMessage={error}
            />
        </Box>
    );
};

export default InlineBeneficiaryForm;